export default __webpack_public_path__ + "static/media/Frank_Ocean_Blonde_NewM.9233ac14.mp4";